export default "/assets/gain.svg";